import { requestLaravel } from "../../../../utils/api";
import { ApiResponse } from "../../core/_models";
import { FormData, PaginationParams, User } from "./_models";

export interface PaginatedUsersResponse {
  list: User[];
  current_page: number;
  limit: number;
  total: number;
  total_pages: number;
}

export function createUser(insertData: FormData) {
  return requestLaravel<ApiResponse<{
    user_id: number;
    reg_id: number;
    email: string;
    user_name: string;
  }>>("/users/create-user", insertData);
}

export function fetchUserList(fetchData: PaginationParams, signal?: AbortSignal): Promise<ApiResponse<PaginatedUsersResponse>> {
  return requestLaravel<ApiResponse<PaginatedUsersResponse>>(
    "/users/get-users-list-paginated",
    fetchData,
    { signal },
  );
}

export function updateUser(updateData: FormData) {
  return requestLaravel<ApiResponse>("/users/update-user", updateData);
}
